"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6554],{

/***/ 66554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var SingleImageSlider = function(param) {
    var src = param.src;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative overflow-scroll whitespace-nowrap single-slider",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            className: "max-w-[999999px] h-full mb-8",
            src: src,
            alt: "slider"
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (SingleImageSlider);


/***/ })

}]);